import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { CalculationResource } from '../model/calculationResource';

@Component({
  selector: 'app-second-step',
  templateUrl: './second-step.component.html',
  styleUrls: ['./second-step.component.scss']
})
export class SecondStepComponent implements OnInit {

  @Input() calculation: CalculationResource | undefined;
  @Output() addCustomer = new EventEmitter<boolean>();

  constructor() { }

  ngOnInit(): void {
  }

  customerStep(): void {
    this.addCustomer.emit(true);
  }

}
